import { useMutation, useQueryClient } from '@tanstack/react-query';
import { setUserAssociation } from '../services/users';
import { userKeys } from './useUsersQuery';
import { handleUserMutationError } from '../services/userErrorHandler';
import type { AdminUser } from '../types/users.types';

interface SetAssociationParams {
    id: string;
    dealer_id: string | null;
    organisation_id: string | null;
}

export const useSetAssociationMutation = () => {
    const queryClient = useQueryClient();

    return useMutation<AdminUser, Error, SetAssociationParams>({
        mutationFn: ({ id, dealer_id, organisation_id }) =>
            setUserAssociation(id, { dealer_id, organisation_id }),
        onSuccess: (_, { id }) => {
            queryClient.invalidateQueries({ queryKey: userKeys.detail(id) });
            queryClient.invalidateQueries({ queryKey: userKeys.lists() });
        },
        onError: (error) => handleUserMutationError(error),
    });
};
